import React from 'react'
import { Button, Card } from 'antd'
import {
  STATE_CREDENTIALS,
  EO_INSURANCE,
  W_9,
  BANK_INFO,
  ADDRESS_COVERAGE,
} from '@components/Signup/constants'
import { getRequiredItems } from '../../helpers'
import useSignupAnalyticsTracker from '@components/Signup/SegmentAnalytics/useSignupAnalyticsTracker'
import useSignupPageView from '@components/Signup/SegmentAnalytics/useSignupPageView'

export const itemTitles = {
  [STATE_CREDENTIALS]: 'State Credential Information',
  [ADDRESS_COVERAGE]: 'Address and Coverage Information',
  [EO_INSURANCE]: 'E&O Insurance',
  [W_9]: 'W-9',
  [BANK_INFO]: 'Bank Account or Card Information',
}

const Info = ({
  userType,
  userInfo: {
    isAppraiser,
    appraiserType,
  },
  handleContinue,
}) => {
  useSignupPageView('Sign Up Start')
  const track = useSignupAnalyticsTracker()

  const itemsToDisplay = getRequiredItems({ userType, isAppraiser, appraiserType })

  const startSetup = () => {
    track({ eventName: 'Sign Up Start Setup Clicked' })
    handleContinue()
  }

  return (
    <div data-testid="signup-info-step">
      <div className='step-header'>
        <h1>Account Setup</h1>
        <p>
          <strong>Congratulations!&nbsp;</strong>
          You have created an account.
           Now we need to collect some information in order to start accepting appraisal orders.
        </p>
      </div>
      <Card>
        <h3>Before We Begin</h3>
        <p>
          To setup your account, you will need to provide the following documents or information.
           You may exit setup and return at any time.
        </p>
        <ol>
          {itemsToDisplay.map(item => {
            return <li key={item}>{itemTitles[item]}</li>
          })}
        </ol>
        <div className='controls'>
          <Button
            type='primary'
            onClick={startSetup}
            data-testid="signup-info-start-setup-button"
          >
            Start Setup
          </Button>
        </div>
      </Card>
    </div>
  )
}

export default Info
